import { render, staticRenderFns } from "./AdmissionPg.vue?vue&type=template&id=e41b5184&scoped=true"
import script from "./AdmissionPg.vue?vue&type=script&lang=js"
export * from "./AdmissionPg.vue?vue&type=script&lang=js"
import style0 from "./AdmissionPg.vue?vue&type=style&index=0&id=e41b5184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41b5184",
  null
  
)

export default component.exports